export function transformOutgoingData(data: any) {
  const { roleNm: name, permissions, context, id } = data;

  return {
    name,
    permissions,
    context,
    id: (id && parseInt(id, 10)) || undefined
  };
}
